module.exports = __webpack_public_path__ + "static/media/my-profile.a7544095.svg";